import React from "react";
import { NavLink, useLocation } from "react-router-dom";

export default function AppNavPills({
  list = [],
  style,
  vertical,
  onClick,
  header,
}) {
  const { state } = useLocation();
  return (
    <ul
      className={`${!vertical && "nav nav-pills"} justify-content-center`}
      style={{ ...style, listStyle: "none" }}
    >
      {header}
      {list.map(
        (
          {
            text,
            disabled,
            path,
            className,
            icon,
            btnStyle,
            vericalText,
            textStyle,
            noText,
          },
          index
        ) => {
          return (
            <li
              className={`nav-item `}
              key={index.toString()}
              style={{ ...btnStyle }}
            >
              {onClick && (
                <button
                  className={`nav-link d-flex ${disabled} ${className} btn btn-sm btn-block btn-light`}
                  onClick={() => {
                    onClick(text);
                  }}
                  style={{
                    flexDirection: vericalText ? "column" : "row",
                    alignItems: "center",
                  }}
                >
                  <div>{icon}</div>
                  {!noText && <div style={textStyle}>{text}</div>}
                </button>
              )}
              {!onClick && (
                <NavLink
                  className={`nav-link d-flex ${disabled} ${
                    className || "btn-light"
                  } btn  btn-sm `}
                  exact
                  to={{ pathname: path, state }}
                  style={{ color: "#333", fontSize: 16, ...btnStyle }}
                >
                  {icon}
                  {!noText && (
                    <span style={{ margin: 5, ...textStyle }}> {text}</span>
                  )}
                </NavLink>
              )}
            </li>
          );
        }
      )}
    </ul>
  );
}
